module.exports = __webpack_public_path__ + "img/12_andy_h.7fa85d07.png";